import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Sticky nav offset so anchor targets aren't hidden behind the header.
const NAV_OFFSET = 90;

function scrollToAnchor(hash, attemptsLeft = 8) {
  const el = document.getElementById(hash.slice(1));
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
    window.scrollTo({ top: Math.max(0, y), left: 0, behavior: 'smooth' });
    return;
  }
  // Target may not have mounted yet after cross-page navigation — retry.
  if (attemptsLeft > 0) {
    requestAnimationFrame(() => scrollToAnchor(hash, attemptsLeft - 1));
  }
}

/**
 * Auto-scrolls the window on route change.
 *  - If the URL has a hash fragment, smooth-scrolls to that anchor (with retry
 *    for pages that mount their anchor targets a frame later), offset by the
 *    sticky nav height.
 *  - Otherwise, jumps to the top of the page.
 */
export default function ScrollToTop() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      scrollToAnchor(hash);
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash, key]);

  return null;
}

